export default __webpack_public_path__ + "static/media/question.bf0445ee.svg";